const CAPTURE_FIELDS = '[data-enter-tab-scope] input, [data-enter-tab-scope] select';

export const advanceReportFieldOnEnter = (event) => {
  if (
    event.key !== 'Enter'
    || event.defaultPrevented
    || event.isComposing
    || event.repeat
    || event.altKey
    || event.ctrlKey
    || event.metaKey
  ) return;

  const target = event.target;
  if (!target?.closest?.('[data-enter-tab-scope]')) return;

  const root = event.currentTarget;
  const fields = Array.from(root.querySelectorAll(CAPTURE_FIELDS)).filter((field) => {
    const type = field.type?.toLowerCase();
    return !field.disabled
      && !field.readOnly
      && !field.closest('details:not([open])')
      && field.getAttribute('aria-hidden') !== 'true'
      && !['hidden', 'checkbox', 'radio', 'button', 'submit', 'file'].includes(type);
  });
  const index = fields.indexOf(target);
  if (index < 0) return;

  event.preventDefault();
  const next = fields[index + (event.shiftKey ? -1 : 1)];
  next?.focus();
};
